export const StatusEnumAccessRequest = {
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
    COMPLETED: 'COMPLETED',
  } as const;
  
  export type StatusEnumAccessRequest = (typeof StatusEnumAccessRequest)[keyof typeof StatusEnumAccessRequest];
  
  export const TypeHistory = {
    CREATION: 'CREATION',
    FEEDBACK: 'FEEDBACK',
    UPDATED: 'UPDATED'
  } as const;
  
  export type TypeHistory = (typeof TypeHistory)[keyof typeof TypeHistory];